import { Select, DatePicker, Row, Col, Button } from "antd";
import React from "react";
import { useForma } from "./useForma";
const { RangePicker } = DatePicker;

export const Forma = () => {
  const { handleSelect, handleRange, handleSubmit, isDisabled } = useForma();

  return (
    <div style={{ minHeight: "20vh" }}>
      <Row gutter={[10, 10]}>
        <Col xs={24} lg={8} xl={6}>
          <Select
            placeholder="Seleccione tipo"
            style={{ width: "100%" }}
            onChange={handleSelect}
            options={[
              {
                value: 1,
                label: "Incidencias",
              },
              {
                value: 2,
                label: "Pagos",
              },
            ]}
          />
        </Col>
        <Col xs={24} lg={8} xl={6}>
          <RangePicker  onChange={handleRange} style={{ width: "100%" }} />
        </Col>
        <Col xs={24} lg={8} xl={6}>
          <Button
            type="primary"
            disabled={isDisabled}
            onClick={handleSubmit}
            style={{ width: "100%" }}
          >
            Generar Xls
          </Button>
        </Col>
      </Row>
     <small>Máximo 4 meses</small> 
    </div>
  );
};
